module.exports = __webpack_public_path__ + "img/ic-filter-next.f9fb8c84.svg";